import extractApiData from 'Helpers/extractApiData'
import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'Helpers/encodeParams'
import {
  MESSAGE_STR_TYPE_CONFIRMATION,
  MESSAGE_STR_TYPE_CONTENTSCAMPAIGN,
  MESSAGE_STR_TYPE_GENERIC,
  MESSAGE_STR_TYPE_WELCOME,
  MESSAGE_TYPE_CONFIRMATION,
  MESSAGE_TYPE_CONTENTSCAMPAIGN,
  MESSAGE_TYPE_GENERIC,
  MESSAGE_TYPE_WELCOME
} from 'Constants'

export const messageTypeToString = messageType => {
  switch (messageType) {
    case MESSAGE_TYPE_GENERIC:
      return MESSAGE_STR_TYPE_GENERIC
    case MESSAGE_TYPE_WELCOME:
      return MESSAGE_STR_TYPE_WELCOME
    case MESSAGE_TYPE_CONFIRMATION:
      return MESSAGE_STR_TYPE_CONFIRMATION
    case MESSAGE_TYPE_CONTENTSCAMPAIGN:
      return MESSAGE_STR_TYPE_CONTENTSCAMPAIGN
  }
}

const endpoints = (baseURL => {
  return {
    //  Archived
    setArchived: (idList, setArchived, filterBy) =>
      `${baseURL}/list/${encodeURIComponent(idList)}/archive/${setArchived ? 'true' : 'false'
      }?${encodeParams({ filterBy })}`,

    // Bee
    getBeePluginUid: idList => `${baseURL}/list/${idList}/bee/uid`,

    // ConcurrentAccess
    getGetConcurrentAccess: (idMessage, autoSaveTimeoutSeconds) =>
      `${baseURL}/message/${idMessage}/access?${encodeParams({
        autoSaveTimeoutSeconds
      })}`,

    deleteConcurrentAccess: (idMessage, all) =>
      `${baseURL}/message/${idMessage}/access?${encodeParams({ all })}`,

    addConcurrentAccess: idMessage => `${baseURL}/message/${idMessage}/access`,

    updateConcurrentAccess: idMessage =>
      `${baseURL}/message/${idMessage}/access`,

    // Dynamic contents
    getDynamicContentByIdMessages: `${baseURL}/messages/contents`,
    getDynamicContentByList: (idList, pageNum, pageSize) =>
      `${baseURL}/list/${idList}/contents?${encodeParams({
        pageNum,
        pageSize
      })}`,

    //  Generic
    generateThumbnail: idMessage => `${baseURL}/thumbnail/${idMessage}`,
    getActiveMessage: (idList, messageType) =>
      `${baseURL}/list/${encodeURIComponent(
        idList
      )}/messagetype/${encodeURIComponent(messageType)}/active`,
    setActiveMessageOfType: (idList, idMessage, messageType) =>
      `${baseURL}/list/${idList}/message/${encodeURIComponent(
        idMessage
      )}/messagetype/${encodeURIComponent(messageType)}/active`,
    getAllMessages: (idList, filterBy, orderBy, pageNum, pageSize) =>
      `${baseURL}/list/${encodeURIComponent(idList)}?${encodeParams({
        filterBy,
        orderBy,
        pageNum,
        pageSize
      })}`,
    getMessagesList: (idList, params) =>
      `${baseURL}/list/${encodeURIComponent(idList)}?${encodeParams(params)}`,
    getEntitiesThatUseMessage: idMessage =>
      `${baseURL}/message/${encodeURIComponent(idMessage)}/entities`,
    setPublic: (idList, setPublic, filterBy) =>
      `${baseURL}/list/${encodeURIComponent(idList)}/publish/${setPublic ? 'true' : 'false'
      }?${encodeParams({ filterBy })}`,
    listMessagesByIds: idList =>
      `${baseURL}/list/${encodeURIComponent(idList)}`,
    messagesDetailByIds: showTemp =>
      `${baseURL}/messages/detail?${encodeParams({ showTemp })}`,

    //  Manipulation
    copyMessage: (idMessage, notes) =>
      `${baseURL}/message/${encodeURIComponent(
        idMessage
      )}/Clone?notes=${encodeURIComponent(notes)}`,
    copyHtmlMessage: (idMessage, notes) =>
      `${baseURL}/message/${encodeURIComponent(
        idMessage
      )}/CloneHtml?notes=${encodeURIComponent(notes)}`,
    deleteMessage: idMessage =>
      `${baseURL}/message/${encodeURIComponent(idMessage)}`,
    getMessageDetails: idMessage =>
      `${baseURL}/message/${encodeURIComponent(idMessage)}`,
    updateMessage: (idMessage, params) =>
      `${baseURL}/message/${encodeURIComponent(idMessage)}?${encodeParams(
        params
      )}`,
    createMessage: params => `${baseURL}/message?${encodeParams(params)}`,
    checkSetMessageType: (idMessage, messageType) =>
      `${baseURL}/message/${encodeURIComponent(
        idMessage
      )}/validate/messagetype/${encodeURIComponent(messageType)}`,
    checkCompliantHtmlMessageType: idMessage =>
      `${baseURL}/message/${encodeURIComponent(
        idMessage
      )}/validate/messagetype/current`,
    setMessageType: (idMessage, messageType) =>
      `${baseURL}/message/${encodeURIComponent(
        idMessage
      )}/messagetype/${encodeURIComponent(messageType)}`,
    getMessageAutoSave: (idList, idMessage) =>
      `${baseURL}/list/${encodeURIComponent(
        idList
      )}/message/${encodeURIComponent(idMessage)}/autosave`,

    setMessageAutoSave: (idList, idMessage) =>
      `${baseURL}/list/${encodeURIComponent(
        idList
      )}/message/${encodeURIComponent(idMessage)}/autosave`,

    deleteMessageAutoSave: (idList, idMessage) =>
      `${baseURL}/list/${encodeURIComponent(
        idList
      )}/message/${encodeURIComponent(idMessage)}/autosave`,
    deleteAttachment: (idMessage, slot) =>
      `${baseURL}/message/${idMessage}/attachment?slot=${encodeURIComponent(
        slot
      )}`,

    // Templates
    addBeeTemplateToList: idList =>
      `${baseURL}/List/${encodeURIComponent(idList)}/Template/Bee`,

    copyBeeTemplateToLists: idTemplate =>
      `${baseURL}/Template/Bee/${encodeURIComponent(idTemplate)}/Copy`,

    deleteBeeTemplate: idTemplate =>
      `${baseURL}/Template/Bee/${encodeURIComponent(idTemplate)}`,

    updateBeeTemplate: idTemplate =>
      `${baseURL}/Template/Bee/${encodeURIComponent(idTemplate)}`,

    getHtmlFromIdTemplate: (id, type) =>
      `${baseURL}/Templates/${id}/html?templateType=${type}`,
    getBeeTemplateDetails: id => `${baseURL}/Template/Bee/${id}`,
    getBeeCentralizedEmailTemplateDetails: id =>
      `${baseURL}/TemplatesCentral/Bee/Email/${id}`,

    getBeeCentralizedNotificationConfirmationTemplateDetails: id =>
      `${baseURL}/TemplatesCentral/Bee/NotificationConfirmation/${id}`,
    getBeeCentralizedWelcomeTemplateDetails: id =>
      `${baseURL}/TemplatesCentral/Bee/NotificationWellcome/${id}`,

    getTemplateDetails: id => `${baseURL}/Template/${encodeURIComponent(id)}`,
    getCentralizedEmailTemplateDetails: id =>
      `${baseURL}/TemplatesCentral/Email/${encodeURIComponent(id)}`,

    getBeeCentralizedEmailTemplates: (filterBy, orderBy, pageNum, pageSize) =>
      `${baseURL}/TemplatesCentral/Bee/Email?${encodeParams({
        filterBy,
        orderBy,
        pageNum,
        pageSize
      })}`,
    getBeeTemplates: (idList, filterBy, orderBy, pageNum, pageSize) =>
      `${baseURL}/List/${encodeURIComponent(
        idList
      )}/Templates/Bee?${encodeParams({
        filterBy,
        orderBy,
        pageNum,
        pageSize
      })}`,
    generateBeeCentralizedTemplate: idTemplate =>
      `${baseURL}/TemplatesCentral/Bee/${idTemplate}/Thumbnail/`,
    updateBeeTemplateThumbnail: (idList, idTemplate) =>
      `${baseURL}/List/${encodeURIComponent(
        idList
      )}/Template/Bee/${encodeURIComponent(idTemplate)}/Thumbnail`,
    getMessageContents: idMessage =>
      `${baseURL}/message/${encodeURIComponent(idMessage)}/contents`,
    getMessageMinimumDetails: (idMessage, params) => {
      if (params) {
        // retrocompatibilità
        return `${baseURL}/message/${encodeURIComponent(
          idMessage
        )}/Lazy?${encodeParams(params)}`
      } else {
        return `${baseURL}/message/${encodeURIComponent(idMessage)}/Lazy`
      }
    }
  }
})(process.env.BEMESS_URL)

export const beMessApiSetArchived = (idList, setArchived, filterBy) => {
  const url = endpoints.setArchived(idList, setArchived, filterBy)

  return apiWrapper({
    method: 'put',
    url: url
  }).then(extractApiData)
}

export const beMessApiGetActiveMessage = (idList, messageType) => {
  const url = endpoints.getActiveMessage(
    idList,
    messageTypeToString(messageType)
  )
  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

// Set active message of type
export const beMessApiSetActiveMessageOfType = (
  idList,
  idMessage,
  messageType
) => {
  const url = endpoints.setActiveMessageOfType(idList, idMessage, messageType)
  return apiWrapper({
    method: 'put',
    url: url
  }).then(extractApiData)
}

export const beMessApiGetAllMessages = (
  idList,
  filterBy = '',
  orderBy = '',
  pageNum = 0,
  pageSize = 0
) => {
  const url = endpoints.getAllMessages(
    idList,
    filterBy,
    orderBy,
    pageNum,
    pageSize
  )
  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const beMessApiGetEntitiesThatUseMessage = idMessage => {
  const url = endpoints.getEntitiesThatUseMessage(idMessage)
  //  'Trigger', 'DynamicContent', 'Anagraphic_Filter', 'Activity_Filter', 'None', 'AutomationWorkflow', 'ABTest', 'Welcome', 'Confirmation', 'AggregateReport'
  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const beMessApiSetPublic = (idList, setPublic, filterBy) => {
  const url = endpoints.setPublic(idList, setPublic, filterBy)
  return apiWrapper({
    method: 'put',
    url: url
  }).then(extractApiData)
}

export const beMessApiCopyMessage = (idMessage, notes) => {
  const url = endpoints.copyMessage(idMessage, notes)

  return apiWrapper({
    method: 'post',
    url: url
  }).then(extractApiData)
}

export const beMessApiCopyHtmlMessage = (idMessage, notes) => {
  const url = endpoints.copyHtmlMessage(idMessage, notes)

  return apiWrapper({
    method: 'post',
    url: url
  }).then(extractApiData)
}

/**
 *
 * @param {number} idMessage
 * @param {Object} data
 * @param {Object} params
 * @param {boolean} params.checkLiquid
 * @param {number} params.idPersonalContent
 * @returns
 */
export const beMessApiUpdateMessage = (idMessage, data, params) => {
  const url = endpoints.updateMessage(idMessage, params)

  return apiWrapper({
    method: 'put',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(extractApiData)
}

/**
 * @description
 * @param {*} data  messageDetails
 * @param {Object} params
 * @param {boolean} params.checkLiquid
 * @param {number} params.idPersonalContent
 */
export const beMessApiCreateMessage = (data, params) => {
  const url = endpoints.createMessage(params)

  return apiWrapper({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(extractApiData)
}

export const beMessApiDeleteMessage = idMessage => {
  const url = endpoints.deleteMessage(idMessage)

  return apiWrapper({
    method: 'delete',
    url: url
  }).then(extractApiData)
}

export const beMessApiGenerateThumbnail = idMessage => {
  const url = endpoints.generateThumbnail(idMessage)

  return apiWrapper({
    method: 'put',
    url: url
  }).then(extractApiData)
}

export const beMessApiGetHtmlFromIdTemplate = (id, type) => {
  const url = endpoints.getHtmlFromIdTemplate(id, type)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const beMessGetBeeTemplateDetails = id => {
  const url = endpoints.getBeeTemplateDetails(id)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const beMessGetBeeCentralizedEmailTemplateDetails = id => {
  const url = endpoints.getBeeCentralizedEmailTemplateDetails(id)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const beMessGetBeeCentralizedNotificationConfirmationTemplateDetails = id => {
  const url = endpoints.getBeeCentralizedNotificationConfirmationTemplateDetails(
    id
  )

  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const beMessGetBeeCentralizedWelcomeTemplateDetails = id => {
  const url = endpoints.getBeeCentralizedWelcomeTemplateDetails(id)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const beMessGetTemplateDetails = id => {
  const url = endpoints.getTemplateDetails(id)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const beMessGetCentralizedEmailTemplateDetails = id => {
  const url = endpoints.getCentralizedEmailTemplateDetails(id)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const beMessListMessagesByIds = (idList, ids) => {
  const url = endpoints.listMessagesByIds(idList)

  return apiWrapper({
    method: 'post',
    url: url,
    data: JSON.stringify(ids)
  }).then(extractApiData)
}

export const beMessGetMessageDetails = id => {
  const url = endpoints.getMessageDetails(id)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const beMessGetMessageContent = idMessage => {
  const url = endpoints.getMessageContents(idMessage)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const beMessCheckSetMessageTypes = (idMessage, messageType) => {
  const url = endpoints.checkSetMessageType(idMessage, messageType)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}
export const beMessCheckCompliantHtmlMessageType = (idMessage, htmlContent) => {
  const url = endpoints.checkCompliantHtmlMessageType(idMessage)
  return apiWrapper({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(htmlContent)
  }).then(extractApiData)
}
export const beMessSetMessageTypes = (idMessage, messageType) => {
  const url = endpoints.setMessageType(idMessage, messageType)
  return apiWrapper({
    method: 'put',
    url: url
  }).then(extractApiData)
}

export const beMessGetMessageAutoSave = (idList, idMessage) => {
  const url = endpoints.getMessageAutoSave(idList, idMessage)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const beMessDeleteMessageAutoSave = (idList, idMessage) => {
  const url = endpoints.deleteMessageAutoSave(idList, idMessage)

  return apiWrapper({
    method: 'delete',
    url: url
  }).then(extractApiData)
}

/**
 * @description Set Autosave message while editing
 * @param {number} idList id of the list where add the template
 * @param {number} idMessage id of the message
 * @param {Object} data template data
 * @param {string} data.Structure
 * @param {string} data.Title
 * @param {number} data.Status
 * @returns {Object} BeeTemplateItemDetails
 * @returns {string} BeeTemplateItemDetails.Structure
 * @returns {number} BeeTemplateItemDetails.Id
 * @returns {string} BeeTemplateItemDetails.Title
 * @returns {boolean} BeeTemplateItemDetails.HasThumbnail
 * @returns {string} BeeTemplateItemDetails.Thumbnail
 * @returns {number} BeeTemplateItemDetails.Type
 * @returns {number} BeeTemplateItemDetails.Category
 */
export const beMessSetMessageAutoSave = (idList, idMessage, data) => {
  const url = endpoints.setMessageAutoSave(idList, idMessage)

  return apiWrapper({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(extractApiData)
}

export const beMessGetDynamicContentByIdMessages = IdMessages => {
  const url = endpoints.getDynamicContentByIdMessages

  return apiWrapper({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({ IdMessages })
  }).then(extractApiData)
}

export const beMessMessagesDetailByIds = (idMessages, showTemp = false) => {
  const url = endpoints.messagesDetailByIds(showTemp)

  return apiWrapper({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(idMessages)
  }).then(extractApiData)
}

export const beMessGetBeeCentralizedEmailTemplates = (
  { filterBy, orderBy, pageNum, pageSize } = { pageNum: 0, pageSize: 0 }
) => {
  const url = endpoints.getBeeCentralizedEmailTemplates(
    filterBy,
    orderBy,
    pageNum,
    pageSize
  )

  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const beMessGetBeeTemplates = (
  { idList, filterBy, orderBy, pageNum, pageSize } = { pageNum: 0, pageSize: 0 }
) => {
  const url = endpoints.getBeeTemplates(
    idList,
    filterBy,
    orderBy,
    pageNum,
    pageSize
  )

  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

/**
 * @description Add a bee template to a list
 * @param {number} idList id of the list where add the template
 * @param {Object} data template data
 * @param {string} data.Structure
 * @param {string} data.Title
 * @param {number} data.Status
 * @returns {Object} BeeTemplateItemDetails
 * @returns {string} BeeTemplateItemDetails.Structure
 * @returns {number} BeeTemplateItemDetails.Id
 * @returns {string} BeeTemplateItemDetails.Title
 * @returns {boolean} BeeTemplateItemDetails.HasThumbnail
 * @returns {string} BeeTemplateItemDetails.Thumbnail
 * @returns {number} BeeTemplateItemDetails.Type
 * @returns {number} BeeTemplateItemDetails.Category
 */
export const beMessAddBeeTemplateToList = (idList, data) => {
  const url = endpoints.addBeeTemplateToList(idList)
  return apiWrapper({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(({ data }) => data)
}

export const beMessCopyBeeTemplateToLists = ({ id, title, lists }) => {
  const url = endpoints.copyBeeTemplateToLists(id)

  return apiWrapper({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({
      Title: title,
      TargetLists: lists
    })
  })
}

export const beMessDeleteBeeTemplate = idTemplate => {
  const url = endpoints.deleteBeeTemplate(idTemplate)

  return apiWrapper({
    method: 'delete',
    url: url
  })
}

export const beMessUpdateBeeTemplate = (idTemplate, template) => {
  const url = endpoints.updateBeeTemplate(idTemplate)
  return apiWrapper({
    method: 'put',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(template)
  }).then(({ data }) => data)
}

export const beMessApiGenerateBeeCentralizedTemplate = idTemplate => {
  const url = endpoints.generateBeeCentralizedTemplate(idTemplate)

  return apiWrapper({
    method: 'post',
    url: url
  }).then(({ data }) => data)
}

export const beMessApiUpdateBeeTemplateThumbnail = (idList, idTemplate) => {
  const url = endpoints.updateBeeTemplateThumbnail(idList, idTemplate)

  return apiWrapper({
    method: 'put',
    url: url
  }).then(({ data }) => data)
}

export const beMessApiGetBeePluginUid = idList => {
  const url = endpoints.getBeePluginUid(idList)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(({ data }) => data)
}

export const beMessApiGetConcurrentAccess = (
  idMessage,
  autoSaveTimeoutSeconds
) => {
  const url = endpoints.getGetConcurrentAccess(
    idMessage,
    autoSaveTimeoutSeconds
  )

  return apiWrapper({
    method: 'get',
    url: url
  }).then(({ data }) => data)
}

export const beMessApiDeleteConcurrentAccess = (idMessage, all = false) => {
  const url = endpoints.deleteConcurrentAccess(idMessage, all)

  return apiWrapper({
    method: 'delete',
    url: url
  }).then(({ data }) => data)
}

export const beMessApiAddConcurrentAccess = idMessage => {
  const url = endpoints.addConcurrentAccess(idMessage)

  return apiWrapper({
    method: 'post',
    url: url
  }).then(({ data }) => data)
}

export const beMessApiUpdateConcurrentAccess = idMessage => {
  const url = endpoints.updateConcurrentAccess(idMessage)

  return apiWrapper({
    method: 'put',
    url: url
  }).then(({ data }) => data)
}

export const beMessApiGetDynamicContentByList = (
  idList,
  pageNum = 0,
  pageSize = 0
) => {
  const url = endpoints.getDynamicContentByList(idList, pageNum, pageSize)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(({ data }) => data)
}

/**
 * @description Delete an attachment and update the message
 * @param {number} idMessage
 * @param {number} slot
 * @returns {boolean}
 */
export const beMessApiDeleteAttachment = (idMessage, slot) => {
  return apiWrapper({
    method: 'delete',
    url: endpoints.deleteAttachment(idMessage, slot)
  }).then(({ data }) => data)
}

export const beMessGetMessageMinimumDetails = (idMessage, params) => {
  const url = endpoints.getMessageMinimumDetails(idMessage, params)
  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}
